import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const insuranceListSlice = createSlice({
  name: "insuranceList",

  initialState: { insuranceList: [], insuranceListLoader: false },
  reducers: {
    setInsuranceList: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.insuranceList = payload;
    },
    setInsuranceListLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.insuranceListLoader = payload;
    },
    resetInsuranceList: (state) => {
      state.insuranceList = [];
    },
  },
});

export const { setInsuranceList, resetInsuranceList, setInsuranceListLoader } =
  insuranceListSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default insuranceListSlice.reducer;
